// Entry-skriptien apufunktiot: domainin ja API-osoitteen selvitys
// skriptitagista. Erillään entry-cmp.ts:stä, jotta funktiot voi importata
// (ja testata) suorittamatta IIFE:ä.

/** Johtaa API-basen bundlen omasta CDN-polusta: .../cmp/banner/v1/cmp.min.js → .../cmp */
export function deriveApiBase(scriptSrc: string): string | null {
  const m = scriptSrc.match(/^(.*)\/banner\/[^/]+\/[^/?#]+([?#].*)?$/);
  return m ? m[1] : null;
}

/** Poimii domain-parametrin skriptin src-URL:sta. */
export function parseDomainFromSrc(scriptSrc: string): string | null {
  const q = scriptSrc.indexOf('?');
  if (q === -1) return null;
  const params = scriptSrc.substring(q + 1).split('#')[0].split('&');
  for (let i = 0; i < params.length; i++) {
    const eq = params[i].indexOf('=');
    const name = eq === -1 ? params[i] : params[i].substring(0, eq);
    if (name === 'domain') {
      return eq === -1 ? '' : decodeURIComponent(params[i].substring(eq + 1));
    }
  }
  return null;
}
